<app-guest-mode-login
    (onLoginOrSignup)="bottomSheetRef.dismiss(true)"
    [customerLanding]="data.customerLanding"
    [accessMode]="data.accessMode"
></app-guest-mode-login>
